
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa/investors",
      function () {
        return require("private-next-pages/sa/investors.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa/investors"])
      });
    }
  